/**
 * Phone normalization, ported from the prototype's `lib/phone/normalize.ts`.
 * US only. 10 digits, or 11 digits with a leading 1. Anything else is not dialable.
 */
const DIGITS = /\D+/g;
export function digitsOf(raw) {
    return raw.replace(DIGITS, '');
}
/** Returns `+1XXXXXXXXXX` for 10/11-digit US numbers, otherwise null. */
export function toE164(raw) {
    if (!raw)
        return null;
    const d = digitsOf(raw);
    if (d.length === 10)
        return `+1${d}`;
    if (d.length === 11 && d.startsWith('1'))
        return `+${d}`;
    return null;
}
/**
 * Sentinel for unparseable input so intake never blocks: `raw:<digits>`, or `raw:<slug>`
 * when there are no digits. Rows with a sentinel are stored with active=false.
 */
export function rawPhoneSentinel(raw) {
    const d = digitsOf(raw);
    if (d.length > 0)
        return `raw:${d}`;
    const slug = raw
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 40);
    return `raw:${slug || 'empty'}`;
}
export function isSentinel(e164) {
    return e164.startsWith('raw:');
}
export function lastFour(e164) {
    return digitsOf(e164).slice(-4);
}
/** `+12125550123` -> `(212) 555-0123`; sentinels and non-US pass through unchanged. */
export function formatE164Display(e164) {
    if (isSentinel(e164))
        return e164;
    const d = digitsOf(e164);
    if (d.length === 11 && d.startsWith('1')) {
        return `(${d.slice(1, 4)}) ${d.slice(4, 7)}-${d.slice(7)}`;
    }
    return e164;
}
/** Fold a lookup result into the prototype's discriminated union. The lookup itself lives in the API. */
export function foldResolution(raw, e164, matches) {
    if (e164 === null)
        return { status: 'unparseable', raw };
    const first = matches[0];
    if (first === undefined)
        return { status: 'none', e164 };
    if (matches.length === 1)
        return { status: 'one', e164, match: first };
    return { status: 'many', e164, matches: [...matches] };
}
//# sourceMappingURL=phone.js.map